import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=2bb52556&scoped=true&"
import script from "./CourseList.vue?vue&type=script&lang=js&"
export * from "./CourseList.vue?vue&type=script&lang=js&"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=2bb52556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb52556",
  null
  
)

export default component.exports